module.exports = __webpack_public_path__ + "static/media/img3.997ffeee.jpg";